<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl" :footer="widget.footer">
        <div v-if="widget.content.count">
            <div class="grid grid-flow-col grid-rows-8 gap-1 justify-center">
                <div></div>
                <div class="text-xs text-gray-300">{{ $t('messages.monday_short') }}</div>
                <div></div>
                <div class="text-xs text-gray-300">{{ $t('messages.wednesday_short') }}</div>
                <div></div>
                <div class="text-xs text-gray-300">{{ $t('messages.friday_short') }}</div>
                <div></div>
                <div></div>
                <div
                    v-for="day in widget.content.days"
                    :key="day.date"
                    :class="day.class"
                    :title="day.title"
                    class="rounded w-2 h-2 md:w-3 md:h-3"
                    @click="dateClicked(day)"
                >
                    {{ day.text }}
                </div>
            </div>
        </div>
        <div v-else class="text-gray-600">
            {{ $t('messages.no_information') }}
        </div>
        <template v-slot:footer>
            <div class="flex justify-between">
                <div>
                    {{ widget.footer }}
                </div>

                <div v-if="widget.content.count">
                    <HelpTooltip>
                        <table>
                            <tbody>
                                <tr v-for="(color, range) in widget.content.legend" :key="range">
                                    <td class="text-right pr-1">{{ range }}</td>
                                    <td>
                                        <div :class="color" class="rounded w-2 h-2 md:w-3 md:h-3" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </HelpTooltip>
                </div>
            </div>
        </template>
    </BaseWidget>
    <!--
bg-gray-100
bg-yellow-200
bg-yellow-300
bg-yellow-400
bg-lime-200
bg-lime-300
bg-lime-400
bg-green-400
bg-green-600
bg-green-800
bg-green-950
--></template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';
import HelpTooltip from '../../HelpTooltip.vue';

export default {
    name: 'CalendarChartWidget',
    emits: ['dateClicked'],
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        HelpTooltip,
        BaseWidget,
    },
    methods: {
        dateClicked(day) {
            if (day.qty !== null) {
                this.$emit('dateClicked', day.date);
            }
        },
    },
};
</script>
